export enum VmapConstants {
  AD_BREAK = 'vmap:AdBreak',
  START = 'start',
  END = 'end',
  BC_BRIGHTCOVE = 'bc:Brightcove',
  BC_THUMBNAIL_URL = 'bc:thumbnailURL',
  CONTENT_LENGTH = 'contentlength',
  TIMEOFFSET = 'timeOffset',
  AD = 'Ad',
  ID = 'id',
  DURATION = 'Duration',
  TEXT_XML = 'text/xml',
  SKIP_OFFSET = 'skipoffset',
  LINEAR = 'Linear',
}
